import type { FC } from 'react';
import { Image, StyleSheet } from 'react-native';

import { ListSection } from '@/features/list/components/ListSection';
import type { GenericPostDetail } from '@/features/posts/types/posts';
import { NavigationListItem } from '@/navigation/components/NavigationListItem';
import { AppRoute } from '@/navigation/types/navigation';
import { useAppTheme } from '@/styles/hooks/useAppTheme';

const styles = StyleSheet.create({
  section: { marginVertical: 0, backgroundColor: 'transparent' },
  item: { paddingVertical: 0, paddingRight: 16 },
  image: { width: 48, height: 48 }
});

type Props = { items: GenericPostDetail[] };

export const CivilProtectionWarnings: FC<Props> = ({ items }) => {
  const theme = useAppTheme();

  return (
    <ListSection style={styles.section}>
      {items.map(
        (
          {
            postId,
            creatorOrSitePicture,
            katwarnEventCodeText,
            katwarnIncidentCategory
          },
          index
        ) => (
          <NavigationListItem
            screen={AppRoute.PostDetail}
            params={{ id: postId }}
            style={styles.item}
            contentStyle={{ paddingLeft: 0 }}
            containerStyle={{ marginVertical: 0 }}
            key={postId}
            icon={() => (
              <Image
                source={{ uri: creatorOrSitePicture?.urls.original }}
                accessibilityIgnoresInvertColors
                tintColor={theme.colors.onSurface}
                style={styles.image}
              />
            )}
            iconStyle={{ paddingLeft: 0 }}
            title={katwarnEventCodeText}
            badge={katwarnIncidentCategory}
            hideRightArrow
            hideDivider={items.length === 1 || index === items.length - 1}
          />
        )
      )}
    </ListSection>
  );
};
